import { flatten } from 'lodash';
import { SceneGraphNode } from 'src/app/engine/models/scene-graph.model';



export function mergeSceneGraphNodes(
  _object1: SceneGraphNode,
  _object2: SceneGraphNode
): { 
  root: SceneGraphNode[], 
  objectIdsUniqueToNew: {[objectId: string]: true},
  objectIdsUniqueToOriginal: {[objectId: string]: true}
} {
  
  const objectIdsUniqueToNew = {};
  const objectIdsUniqueToOriginal = {};

  // merge lives in nested scope, so we can collect new object ids through each recursion.
  function merge(object1: SceneGraphNode, object2: SceneGraphNode): SceneGraphNode[] {

    if (object1.objectId !== object2.objectId) {
      objectIdsUniqueToNew[object2.objectId] = true;
      return [object1, object2];
    }
      
    // recursive merging won't happen if an object's objects are undefined.
    // need to look for unique objects here too.
    if (object1.objects === undefined && object2.objects) {
      for (const object of object2.objects) {
        objectIdsUniqueToNew[object.objectId] = true;
      }
      return [{...object2}];
    }

    if (object1.objects && object2.objects === undefined) {
      for (const object of object1.objects) {
        objectIdsUniqueToOriginal[object.objectId] = true;
      }
      return [{...object1}];
    }

    if (object1.objects === undefined && object2.objects === undefined) {
      return [{ ...object1 }];
    }
    
    const objects = [];
  
    // if an object exists in both groups, it needs to be merged recursively
    // if not, it can simply be appended.
    for (const obj1 of object1.objects) {
      const obj2 = object2.objects.find(o => o.objectId === obj1.objectId);
      if (obj2) {
        objects.push(merge(obj1, obj2));
      } else {
        objectIdsUniqueToOriginal[obj1.objectId] = true;
        objects.push(obj1);
      }
    }
  
    // must compare the other way, to find objects in group 2 that aren't in group 1.
    for (const obj2 of object2.objects) {
      const obj1 = object1.objects.find(o => o.objectId === obj2.objectId);
      if (!obj1) {
        objectIdsUniqueToNew[obj2.objectId] = true;
        objects.push(obj2);
      }
    }
  
    
    // don't mutate
    const _obj = { ...object1 };
    
    // collect the objects we found recursively
    _obj.objects = flatten(objects);
    
    return [_obj];
  
  }

  const root = merge(_object1, _object2);

  return {
    root,
    objectIdsUniqueToNew,
    objectIdsUniqueToOriginal
  };
}
